import * as z from "zod/v4";

export const logSignupFormAnalyticsSchema = {
  name: "logSignupFormAnalytics" as const,
  input: z.object({
    idempotencyKey: z.string(),
    formId: z.string(),
    type: z.enum(["view", "submit"]),
  }),
  output: z.object({ success: z.boolean() }),
};
